import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import Icon from '../icon/Icon';
import ICONS from '@/common-utils/enums/icons';
import Entity from '../entity/Entity';
import TooltipHelper from '../tooltip/TooltipHelper';

/**
 *
 * @param root0
 * @param root0.value
 * @param root0.namespace
 * @returns {JSX} RenderDateWithFromTimeAndColor
 */
function RenderDateWithFromTimeAndColor({ value, namespace }) {

    // Check
    if (!value) {
        return null;
    }

    // Translation
    const { i18n } = useTranslation();

    // Constants
    const LANG = i18n.resolvedLanguage;
    const LUXON_DATE = DateTime.fromISO(value, { locale: LANG });
    const DAYS_DIFF = DateTime.now().diff(LUXON_DATE, ['days']).toObject().days;
    const MAX_DAY_COUNT = 7;
    const ALERT_LEVEL = DAYS_DIFF >= MAX_DAY_COUNT ?
        2
        : DAYS_DIFF >= 3 ?
            1
            : null;

    // CSS and Text
    const tooltipEntity = ALERT_LEVEL === 1 ? 'tooltip.date.alert.warning' : 'tooltip.date.alert.error';
    const triggerClass = ALERT_LEVEL === 1 ? 'flex m-0 items-center text-warning cursor-default' : 'flex m-0 items-center text-danger cursor-default';

    return (
        <div>
            <div>
                <small className='whitespace-nowrap'>
                    {LUXON_DATE.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}
                </small>
            </div>
            {
                LUXON_DATE && ALERT_LEVEL ?
                    <TooltipHelper
                        trigger={
                            <>
                                <Icon icon={ICONS.WARNING} className={'mr-1'} />
                                {LUXON_DATE.toRelative({ base: DateTime.now() })}
                            </>
                        }
                        triggerClass={triggerClass}
                        content={
                            <Entity
                                entity={tooltipEntity}
                                namespace={namespace}
                                data={{
                                    days:
                                        ALERT_LEVEL === 1 ? LUXON_DATE.toRelative({ base: DateTime.now() }, 'days') : MAX_DAY_COUNT
                                }}
                            />}
                    />
                    : LUXON_DATE ?
                        LUXON_DATE.toRelative({ base: DateTime.now() })
                        : false
            }
        </div>
    );

}
RenderDateWithFromTimeAndColor.propTypes = {
    value: PropTypes.string.isRequired,
    namespace: PropTypes.string.isRequired
};

export default RenderDateWithFromTimeAndColor;